import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'
import _imports_1 from '@/app/ui/assets/svg/attachment.svg'
import _imports_2 from '@/app/ui/assets/svg/trash.svg'


const _hoisted_1 = {
  key: 1,
  class: "h-full"
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "flex flex-row my-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200" }, " Edit Announcement ", -1)
const _hoisted_5 = { class: "inline-flex" }
const _hoisted_6 = {
  key: 1,
  class: "flex flex-row h-full pb-4 "
}
const _hoisted_7 = {
  class: "w-2/3 px-4 text-12px xxl:text-14px pb-24 overflow-y-auto",
  style: {"padding-right":"10%"}
}
const _hoisted_8 = { class: "pt-4" }
const _hoisted_9 = { class: "py-2 w-full" }
const _hoisted_10 = { class: "font-semibold text-black-lp-300 mb-2" }
const _hoisted_11 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-gray-700" }
const _hoisted_12 = { class: "text-12px text-gray-lp-500" }
const _hoisted_13 = { class: "py-2 w-full" }
const _hoisted_14 = { class: "font-semibold text-black-lp-300 mb-2" }
const _hoisted_15 = { class: "py-2 w-full" }
const _hoisted_16 = { class: "mb-2" }
const _hoisted_17 = { class: "font-semibold text-black-lp-300" }
const _hoisted_18 = { class: "text-gray-lp-500" }
const _hoisted_19 = { class: "flex flex-col my-4" }
const _hoisted_20 = {
  key: 0,
  class: "items-center text-12px justify-between flex flex-row cursor-pointer border-2 border-dashed py-3 px-4 rounded-lg my-2"
}
const _hoisted_21 = { class: "flex flex-row w-4/5" }
const _hoisted_22 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-3 mr-3",
  alt: "attachment"
}, null, -1)
const _hoisted_23 = { class: "text-gray-lp-300" }
const _hoisted_24 = { class: "flex flex-row" }
const _hoisted_25 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-3 mr-3",
  alt: "attachment"
}, null, -1)
const _hoisted_26 = { class: "text-gray-lp-300" }
const _hoisted_27 = { class: "text-red-lp-200 font-semibold" }
const _hoisted_28 = { class: "py-2 w-full" }
const _hoisted_29 = { class: "font-semibold text-black-lp-300 mb-2" }
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "font-semibold text-black-lp-300" }, "Banner", -1)
const _hoisted_31 = { class: "text-gray-lp-500" }
const _hoisted_32 = { class: "flex flex-row align-middle items-center" }
const _hoisted_33 = {
  key: 1,
  class: "w-3/4 h-48 object-cover bg-gray-400"
}
const _hoisted_34 = { class: "pt-2 w-full" }
const _hoisted_35 = { class: "font-semibold text-black-lp-300 mb-2" }
const _hoisted_36 = { class: "py-2 flex flex-row w-full" }
const _hoisted_37 = { class: "w-3/5" }
const _hoisted_38 = {
  key: 0,
  class: "text-red-lp-100 text-12px xxl:text-14px mt-2 ml-1"
}
const _hoisted_39 = { class: "py-4 border-t border-gray-lp-400" }
const _hoisted_40 = { class: "pt-2 text-12px xxl:text-14px text-gray-lp-300 font-semibold" }
const _hoisted_41 = { class: "my-1 text-gray-lp-500" }
const _hoisted_42 = { class: "flex flex-row" }
const _hoisted_43 = {
  class: "w-1/4",
  style: {"min-width":"180px"}
}
const _hoisted_44 = {
  class: "w-1/4",
  style: {"min-width":"180px"}
}
const _hoisted_45 = { class: "py-4 border-t border-gray-lp-400" }
const _hoisted_46 = { class: "pt-2 text-12px xxl:text-14px text-gray-lp-300 font-semibold" }
const _hoisted_47 = { class: "my-1 text-gray-lp-500" }
const _hoisted_48 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400 mt-4" }
const _hoisted_49 = { class: "py-3" }
const _hoisted_50 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Status ", -1)
const _hoisted_51 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_52 = { class: "flex" }
const _hoisted_53 = { class: "capitalize" }
const _hoisted_54 = { class: "py-3" }
const _hoisted_55 = { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }
const _hoisted_56 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_57 = { class: "text-gray-lp-500" }
const _hoisted_58 = { class: "py-3" }
const _hoisted_59 = { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }
const _hoisted_60 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_61 = { class: "text-gray-lp-500" }
const _hoisted_62 = { class: "py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_text_editor = _resolveComponent("text-editor")!
  const _component_Pickers = _resolveComponent("Pickers")!
  const _component_check_box = _resolveComponent("check-box")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_ButtonOutline = _resolveComponent("ButtonOutline")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
          key: 0,
          onBack: _ctx.goBack
        }, null, 8, ["onBack"]))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("img", {
                src: _imports_0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                class: "w-5 mr-3 cursor-pointer",
                alt: "back"
              }),
              _hoisted_4
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_button_fill, {
                title: _ctx.$t('announcement.save'),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.target.length > 0 ? _ctx.onOpenSave() : null)),
                isDisabled: _ctx.target.length <= 0,
                class: "px-8 bg-red-lp-300"
              }, null, 8, ["title", "isDisabled"])
            ])
          ]),
          (_ctx.isError || _ctx.isErrorEdit)
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 0,
                errorType: _ctx.errorCause,
                onTryAgain: _ctx.isErrorEdit ? _ctx.onSave : _ctx.getDetailData
              }, null, 8, ["errorType", "onTryAgain"]))
            : (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('announcement.nameActivity')), 1),
                      _createVNode("div", {
                        class: 
                `${_ctx.inputFocus && 'input'}
              relative
              py-1.5
              xxl:py-3
              px-3
              rounded-md
              border
              border-gray-lp-400
              my-1.5
              text-black-lp-300
              flex
              flex-row`
              
                      }, [
                        _withDirectives(_createVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.detailData.name = $event)),
                          placeholder: _ctx.$t('announcement.placeholderName'),
                          maxlength: 56,
                          type: "text",
                          class: "outline-none focus:outline-none w-4/5",
                          onFocus: _cache[4] || (_cache[4] = 
                  () => {
                    _ctx.inputFocus = true;
                  }
                ),
                          onBlur: _cache[5] || (_cache[5] = 
                  () => {
                    _ctx.inputFocus = false;
                  }
                )
                        }, null, 40, ["placeholder"]), [
                          [_vModelText, _ctx.detailData.name]
                        ]),
                        _createVNode("div", _hoisted_11, [
                          _createVNode("p", _hoisted_12, _toDisplayString(_ctx.detailData.name.length) + "/" + _toDisplayString(56), 1)
                        ])
                      ], 2)
                    ]),
                    _createVNode("div", _hoisted_13, [
                      _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('announcement.description')), 1),
                      _createVNode(_component_text_editor, {
                        modelValue: _ctx.description,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.description = $event)),
                        placeholder: _ctx.$t('announcement.placeholderDescription'),
                        maxLength: 1000
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _createVNode("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, [
                        _createVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('announcement.attachment')), 1),
                        _createVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('announcement.optional')), 1)
                      ]),
                      _createVNode("div", _hoisted_19, [
                        (_ctx.fileName && !_ctx.isDataValidate)
                          ? (_openBlock(), _createBlock("div", _hoisted_20, [
                              _createVNode("div", _hoisted_21, [
                                _hoisted_22,
                                _createVNode("div", _hoisted_23, _toDisplayString(_ctx.fileName), 1)
                              ]),
                              _createVNode("div", {
                                class: "text-red-lp-200 font-semibold",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$refs.file.click()))
                              }, _toDisplayString(_ctx.loadingUpload ? "Loading..." : _ctx.$t('announcement.changeFile')), 1),
                              _createVNode("img", {
                                src: _imports_2,
                                alt: "trash",
                                class: "w-5 cursor-pointer ml-4",
                                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.setDefault && _ctx.setDefault(...args)))
                              })
                            ]))
                          : (_openBlock(), _createBlock("div", {
                              key: 1,
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$refs.file.click())),
                              class: "items-center text-12px justify-between flex flex-row cursor-pointer border-2 border-dashed py-3 px-4 rounded-lg my-2"
                            }, [
                              _createVNode("div", _hoisted_24, [
                                _hoisted_25,
                                _createVNode("div", _hoisted_26, _toDisplayString(_ctx.attachment
                        ? _ctx.attachment.slice(
                            _ctx.attachment.search(/([a-zA-Z0-9]+).(pdf)/g)
                          ).length > 2
                          ? _ctx.attachment.slice(
                              _ctx.attachment.search(/([a-zA-Z0-9]+).(pdf)/g)
                            )
                          : _ctx.attachment.replace(
                              /([a-z]+)\:\/\/([a-z]+).([a-z]+).com\/([a-z\-]+)\//g,
                              ""
                            ).length > 2
                          ? _ctx.attachment.replace(
                              /([a-z]+)\:\/\/([a-z]+).([a-z]+).com\/([a-z\-]+)\//g,
                              ""
                            )
                          : _ctx.attachment
                        : "-"), 1)
                              ]),
                              _createVNode("div", _hoisted_27, _toDisplayString(_ctx.loadingUpload ? "Loading..." : _ctx.$t('announcement.changeFile')), 1)
                            ])),
                        _createVNode("input", {
                          type: "file",
                          ref: "file",
                          onChange: _cache[10] || (_cache[10] = 
                  e => {
                    _ctx.onUploadPdf(e);
                  }
                ),
                          accept: `.pdf`,
                          class: "hidden",
                          disabled: _ctx.isLoading
                        }, null, 40, ["accept", "disabled"]),
                        _withDirectives(_createVNode("p", { class: "text-12px text-red-lp-700" }, _toDisplayString(_ctx.$t('announcement.invalidFileMessage')), 513), [
                          [_vShow, _ctx.isDataValidate]
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_28, [
                      _createVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('announcement.optional')), 1)
                      ]),
                      _createVNode("div", _hoisted_32, [
                        (_ctx.imagePreview || _ctx.bannerImage)
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              src: _ctx.imagePreview || _ctx.bannerImage,
                              alt: "banner",
                              class: "w-3/4 h-48 object-cover"
                            }, null, 8, ["src"]))
                          : (_openBlock(), _createBlock("div", _hoisted_33)),
                        _createVNode("div", {
                          class: "border border-gray-lp-400 rounded-md p-3 ml-5 cursor-pointer flex flex-row align-middle font-semibold text-black-lp-300 text-center",
                          style: {"height":"30%"},
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$refs.banner.click()))
                        }, _toDisplayString(_ctx.$t('announcement.changeFile')), 1),
                        _withDirectives(_createVNode("img", {
                          src: _imports_2,
                          alt: "trash",
                          class: "w-5 cursor-pointer ml-4",
                          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.deleteBannerImage && _ctx.deleteBannerImage(...args)))
                        }, null, 512), [
                          [_vShow, !_ctx.imagePreview && _ctx.bannerImage]
                        ]),
                        _withDirectives(_createVNode("img", {
                          src: _imports_2,
                          alt: "trash",
                          class: "w-5 cursor-pointer ml-4",
                          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.setDefaultImage && _ctx.setDefaultImage(...args)))
                        }, null, 512), [
                          [_vShow, _ctx.imagePreview]
                        ]),
                        _createVNode("input", {
                          type: "file",
                          ref: "banner",
                          onChange: _cache[14] || (_cache[14] = e => _ctx.onUploadImage(e)),
                          accept: `.jpg,.png`,
                          class: "hidden",
                          disabled: _ctx.isLoading
                        }, null, 40, ["accept", "disabled"])
                      ]),
                      _createVNode("div", {
                        class: 
                `${_ctx.bannerError ? 'text-red-lp-100' : `text-gray-lp-500`} mt-2`
              
                      }, _toDisplayString(_ctx.$t('announcement.captionBanner')), 3)
                    ]),
                    _createVNode("div", _hoisted_34, [
                      _createVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('announcement.releaseDate')), 1)
                    ]),
                    _createVNode("div", _hoisted_36, [
                      _createVNode("div", _hoisted_37, [
                        _createVNode("div", {
                          class: 
                  `flex flex-row w-full ${_ctx.invalidEndDate && 'date-error'}`
                
                        }, [
                          _createVNode(_component_Pickers, {
                            modelValue: _ctx.releasedAt,
                            modelValueTime: _ctx.releaseTime,
                            onSelected: _ctx.inputDateStart,
                            onSelectedTime: _ctx.inputDateStartTime,
                            minuteStep: 1,
                            minDate: new Date(),
                            showTimePicker: true,
                            showDatePicker: true
                          }, null, 8, ["modelValue", "modelValueTime", "onSelected", "onSelectedTime", "minDate"])
                        ], 2),
                        (_ctx.invalidEndDate)
                          ? (_openBlock(), _createBlock("span", _hoisted_38, _toDisplayString(_ctx.$t('announcement.invalidEndDate')), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createVNode("div", _hoisted_39, [
                      _createVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('announcement.target')), 1),
                      _createVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('announcement.targetHint')), 1),
                      _createVNode("div", _hoisted_42, [
                        _createVNode("div", _hoisted_43, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options.slice(0, 3), (item, index) => {
                            return (_openBlock(), _createBlock("div", {
                              key: index,
                              class: `${index === _ctx.options.length - 1 && 'pb-2'}`
                            }, [
                              _createVNode(_component_check_box, {
                                item: item,
                                index: index,
                                length: _ctx.options.length,
                                keyName: _ctx.keyName,
                                isSelected: _ctx.isSelected,
                                onChooseSelect: _ctx.onChooseSelect
                              }, null, 8, ["item", "index", "length", "keyName", "isSelected", "onChooseSelect"])
                            ], 2))
                          }), 128))
                        ]),
                        _createVNode("div", _hoisted_44, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options.slice(3), (item, index) => {
                            return (_openBlock(), _createBlock("div", {
                              key: index + 3,
                              class: `${index === _ctx.options.length - 1 && 'pb-2'}`
                            }, [
                              _createVNode(_component_check_box, {
                                item: item,
                                index: index + 3,
                                length: _ctx.options.length,
                                keyName: _ctx.keyName,
                                isSelected: _ctx.isSelected,
                                onChooseSelect: _ctx.onChooseSelect
                              }, null, 8, ["item", "index", "length", "keyName", "isSelected", "onChooseSelect"])
                            ], 2))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_45, [
                      _createVNode("div", _hoisted_46, _toDisplayString(_ctx.$t('announcement.pinnedMessage')), 1),
                      _createVNode("div", _hoisted_47, _toDisplayString(_ctx.$t('announcement.pinnedHint')), 1),
                      _createVNode(_component_Toggle, {
                        onChange: () => _ctx.onToggle(!_ctx.pinned),
                        isActive: _ctx.pinned
                      }, null, 8, ["onChange", "isActive"])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_48, [
                  _createVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createVNode("div", _hoisted_51, [
                      _createVNode("div", _hoisted_52, [
                        _createVNode("div", {
                          class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.detailData.status.toLowerCase() === 'sent'
                      ? 'bg-green-lp-300 text-green-lp-200'
                      : 'bg-gray-lp-200 text-black-lp-300'
                  }`
                
                        }, [
                          _createVNode("span", _hoisted_53, _toDisplayString(_ctx.detailData.status), 1)
                        ], 2)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_54, [
                    _createVNode("div", _hoisted_55, _toDisplayString(_ctx.$t('announcement.createdAt')), 1),
                    _createVNode("div", _hoisted_56, _toDisplayString(_ctx.formatDate(_ctx.detailData.createdAt)), 1),
                    _createVNode("div", _hoisted_57, _toDisplayString(_ctx.detailData.createdName), 1)
                  ]),
                  _createVNode("div", _hoisted_58, [
                    _createVNode("div", _hoisted_59, _toDisplayString(_ctx.$t('announcement.lastModified')), 1),
                    _createVNode("div", _hoisted_60, _toDisplayString(_ctx.formatDate(_ctx.detailData.updatedAt || _ctx.detailData.createdAt)), 1),
                    _createVNode("div", _hoisted_61, _toDisplayString(_ctx.detailData.updatedBy || _ctx.detailData.createdName), 1)
                  ]),
                  _createVNode("div", _hoisted_62, [
                    _createVNode(_component_ButtonOutline, {
                      onClick: _cache[15] || (_cache[15] = () => _ctx.onOpenDelete(true)),
                      icon: "delete",
                      class: "flex flex-col items-center justify-center cursor-pointer btn-delete w-1/4",
                      style: {"max-width":"25%","cursor":"pointer"}
                    })
                  ])
                ])
              ]))
        ])),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.isDeleteSuccess ? _ctx.goList : _ctx.goBack,
      title: _ctx.$t('announcement.successTitle'),
      message: `${_ctx.$t('announcement.news')} “${_ctx.detailData.name}” ${_ctx.$t('announcement.successChanged')}`,
      image: "image-modal-success",
      textSuccess: _ctx.$t('announcement.ok'),
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message", "textSuccess"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: _ctx.$t('announcement.confirmLeaveTitle'),
      message: _ctx.$t('announcement.confirmLeaveMessage'),
      image: "are-you-sure",
      textSuccess: _ctx.$t('announcement.leave'),
      textCancel: _ctx.$t('announcement.back'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onSave,
      onClose: _ctx.onCloseSave,
      title: _ctx.$t('announcement.confirmSaveTitle'),
      message: `${_ctx.$t('announcement.confirmSaveMessageTwo')} “${_ctx.detailData.name}”`,
      image: "are-you-sure",
      textSuccess: _ctx.$t('announcement.save'),
      textCancel: _ctx.$t('announcement.back'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openSave]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onDelete,
      onClose: () => _ctx.onOpenDelete(false),
      title: _ctx.$t('announcement.confirmDeleteTitle'),
      message: _ctx.$t('announcement.confirmDeleteMessage'),
      image: "delete-confirm",
      textSuccess: _ctx.$t('announcement.delete'),
      textCancel: _ctx.$t('announcement.back'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.isConfirmDelete]
    ])
  ], 64))
}